import {useState} from 'react';
import './_hotspot.scss';

export type VButtonProps = {
    id: string;
    title: string;
    content: string;
    url: string;
}

export default function Hotspot({id, title, content, url}: VButtonProps) {
    const [isHovered, setIsHovered] = useState(false);

    function onMouseEnter() {
        setIsHovered(true);
    }

    function onMouseLeave() {
        setIsHovered(false);
    }

    return <div
        id={id}
        className={'hotspot' + (isHovered ? ' show-popup' : '')}
        onMouseEnter={onMouseEnter}
    >
        <div className='hotspot__popup'
            onMouseLeave={onMouseLeave}
        >
            <div>
                <div className='hotspot__popup__title'>{title}</div>
                <div className='hotspot__popup__content'>{content}</div>
                <a href={url} className='hotspot__popup__link' target='_blank' rel='noreferrer'>Click here to view</a>
                <div className='hotspot__popup__indicator'>
                    <img src="./assets/images/triangle.svg" alt=""/>
                </div>
            </div>
        </div>

    </div>;
}
